/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

import {
    Component,
    Injectable,
    Injector,
    Type,
} from '@angular/core';
import { ObservableList } from 'nsx-alb-ui-components';

export interface IAviDialogProps {
    id: string;
    component: Type<Component>;
    componentProps?: Record<string, any>;
    injector?: Injector;
}

// Token used when registering as a downgraded service in AJS.
export const DIALOG_SERVICE_TOKEN = 'dialogService';

/**
 * Service for adding and removing dialogs.
 * @author alextsg
 */
@Injectable({
    providedIn: 'root',
})
export class DialogService extends ObservableList<IAviDialogProps, string> {
    protected getID(item: IAviDialogProps): string {
        return item.id;
    }
}
